import appCaptainInvoices from "../../views/appPlans/captainInvoices.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("captaininvoices", {
    url: "captaininvoices/:id",
    parent: "app",
    views: {
      view: {
        template: appCaptainInvoices,
      },
    },
    reloadOnSearch: false,
    data: { title: "Captain Invoices" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/captainInvoices/captainInvoices.urls.js